// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"3129ed01","156":"10b30f6c","237":"50e62514","249":"0f76d4fe","359":"15b654e2","465":"22d97995","540":"d41e62be","555":"4f06a658","592":"d73af141","626":"a7c2f49a","686":"4b23ffd8","698":"273e13de"}[chunkId] + ".chunk.css";
};